import { Base } from '@studiometa/js-toolkit';
import MenuItem from './MenuItem.js';
import { gsap } from 'gsap';

/**
 * Toast component
 */
export default class Menu extends Base {
  submenuIsOpen = false;
  menuIsOpen = false;
  timeout = null;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Menu',
    refs: [
      'item[]',
      'close[]',
      'overlay',
      'burger',
      'nav',
      'wrapper',
      'navItems[]',
      'menuContainer',
    ],
    components: {
      MenuItem,
    },
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    if (this.isMobile) {
      this.initMobileTimeline();
    } else {
      this.$refs.nav.style.pointerEvents = 'auto';
    }

    document.documentElement.style.setProperty(
      '--submenu-height',
      `${this.$refs.menuContainer.offsetHeight}px`,
    );
  }

  /**
   *
   */
  onBurgerClick() {
    if (!this.menuIsOpen) {
      this.tl.play(0);
      document.body.classList.add('menu-is-open');
    } else {
      this.$children.MenuItem.forEach((element) => {
        if (element.isOpen === true) {
          element.closeSubmenu();
        }
      });
      document.body.classList.remove('menu-is-open');
      this.tl.reverse();
    }

    this.menuIsOpen = !this.menuIsOpen;
  }

  /**
   *
   */
  initMobileTimeline() {
    this.tl = gsap.timeline({ paused: true });
    this.tl.set(document.body, { overflow: 'hidden' });

    this.tl.to(this.$refs.wrapper, {
      width: '100%',
      boxShadow: '0 0 0 0',
      duration: 0.6,
      ease: 'power3.inOut',
    });

    this.tl.to(
      this.$refs.overlay,
      {
        opacity: 1,
        duration: 0.3,
        ease: 'power3.out',
      },
      '-=0.1',
    );

    this.tl.set(this.$refs.nav, { opacity: 1 });

    this.tl.fromTo(
      this.$refs.navItems,
      {
        opacity: 0,
        y: -10,
      },
      {
        stagger: {
          each: 0.08,
        },
        clearProps: 'transform',
        ease: 'power3.out',
        opacity: 1,
        duration: 0.8,
        y: 0,
      },
    );
  }

  /**
   *
   */
  onMenuItemOpen() {
    this.showOverlay();
  }

  /**
   * Close last submenu when clicked on another submenu
   * @returns {void}
   */
  onMenuItemClose() {
    this.hideOverlay();
  }

  /**
   *
   */
  onOverlayMouseenter() {
    this.hideOverlay();
  }

  /**
   *
   */
  showOverlay() {
    this.$refs.overlay.classList.remove('pointer-events-none', 'opacity-0');
  }

  /**
   *
   */
  hideOverlay() {
    this.$refs.overlay.classList.add('pointer-events-none', 'opacity-0');
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    const propertyValue = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--breakpoint-l');
    const pixelValue = Number.parseFloat(propertyValue) * 16;
    return window.innerWidth <= pixelValue;
  }
}
